/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "5c64cf1bcbc65380b4a378c74074168b153f7cff";
